let wishlistPopupTimeout
let lastFocusedElement
let isPopupVisible = false
let usingKeyboard = false

window.showWishlistPopup = function (messageHtml) {
  const popup = document.getElementById('wishlist-popup')
  if (!popup) return

  lastFocusedElement = document.activeElement

  popup.innerHTML = messageHtml
  popup.hidden = false
  popup.classList.add('show')
  isPopupVisible = true

  // focus first focusable child or the popup itself
  setTimeout(() => {
    const focusTarget =
      popup.querySelector('a, button, [tabindex]:not([tabindex="-1"])') ||
      popup
    focusTarget.focus()
  }, 50)

  clearTimeout(wishlistPopupTimeout)

  wishlistPopupTimeout = setTimeout(() => {
    popup.classList.remove('show')
    popup.hidden = true
    isPopupVisible = false

    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus()
    }
  }, 3000)
}

/* freeze Tab while popup is visible */
document.addEventListener('keydown', (e) => {
  if (e.key === 'Tab') {
    usingKeyboard = true
    if (isPopupVisible) e.preventDefault() // trap focus
  }
})

/* reset keyboard mode on mouse interaction */
document.addEventListener('mousedown', () => {
  usingKeyboard = false
})


class ClearSearchButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.input = null;
    this.form = null;
  }

  connectedCallback() {
    this.form = this.closest('form');
    if (!this.form) return;

    this.input = this.form.querySelector('input[name="q"]');
    if (!this.input) return;

    // Initial visibility
    // this.toggleVisibility();

    // Clear input on click
    this.button.addEventListener('click', () => {
      this.input.value = '';
      this.input.focus();
      // this.toggleVisibility();
    });
  }

}

customElements.define('clear-search-button', ClearSearchButton);


// Select focus fix
document.addEventListener('focusin', (e) => {
  const select = e.target.closest('.pretty-select select');
  if (select) {
    select.closest('.pretty-select')?.classList.add('is-focused');
  }
});

document.addEventListener('focusout', (e) => {
  const select = e.target.closest('.pretty-select select');
  if (select) {
    // slight delay to allow clicks on dropdown items to not remove focus instantly
    setTimeout(() => {
      if (document.activeElement !== select) {
        select.closest('.pretty-select')?.classList.remove('is-focused');
      }
    }, 10);
  }
});


/* Globo checkbox fix */
document.addEventListener('keydown', (e) => {
  if (e.key === ' ' || e.code === 'Space') {
    const el = document.activeElement;

    if (
      el.tagName === 'LABEL' &&
      el.classList.contains('globo-option') && // optional: limit to globo label
      el.closest('.globo-form') && // make sure it's inside .globo-form
      el.hasAttribute('for')
    ) {
      const targetId = el.getAttribute('for');
      const checkbox = document.getElementById(targetId);

      if (
        checkbox &&
        checkbox.type === 'checkbox' &&
        checkbox.closest('.globo-form')
      ) {
        e.preventDefault();
        checkbox.click();
      }
    }
  }
});



/* Skipping filtres */
document.querySelector('.skip-link.skip-filters')?.addEventListener('click', function(e) {
  e.preventDefault()
  const firstProduct = document.querySelector('.product-block__inner')
  if (firstProduct) {
    firstProduct.focus()
  }
})



function patchLvOptionSlideKeyboardSupport() {
  document.querySelectorAll('lv-option-slide').forEach((slideEl) => {
    const slideContent = slideEl.querySelector('.lv-option-slide-items');
    if (!slideContent) return;

    slideContent.addEventListener('focusin', (event) => {
      const focusedEl = event.target;
      if (!(focusedEl instanceof HTMLElement)) return;
      if (!slideContent.contains(focusedEl)) return;

      const containerRect = slideEl.getBoundingClientRect();
      const focusedRect = focusedEl.getBoundingClientRect();
      const currentOffset = parseFloat(slideContent.dataset._patchedOffset || '0');
      const maxOffset = Math.max(0, slideContent.scrollWidth - slideEl.clientWidth);

      let newOffset = currentOffset;

      const focusedLeft = focusedRect.left;
      const focusedRight = focusedRect.right;
      const containerLeft = containerRect.left;
      const containerRight = containerRect.right;

      if (focusedLeft < containerLeft) {
        const delta = containerLeft - focusedLeft + 16;
        newOffset = Math.max(0, currentOffset - delta);
      } else if (focusedRight > containerRight) {
        const delta = focusedRight - containerRight + 16;
        newOffset = Math.min(maxOffset, currentOffset + delta);
      } else {
        return;
      }

      slideContent.style.transform = `translateX(-${newOffset}px)`;
      slideContent.dataset._patchedOffset = newOffset;
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', patchLvOptionSlideKeyboardSupport);
} else {
  patchLvOptionSlideKeyboardSupport();
}



/* Custom Cursor */
(function() {
  const COOKIE_NAME = 'custom_cursor_enabled';
  const COOKIE_EXPIRY_DAYS = 90;
  
  function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = 'expires=' + date.toUTCString();
    document.cookie = name + '=' + value + ';' + expires + ';path=/';
  }
  
  function getCookie(name) {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
  
  function initCustomCursor() {
    const cursor = document.getElementById('custom-cursor');
    if (!cursor) return;
    
    // Check for reduced motion preference
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    
    const cursorSize = parseInt(cursor.style.width) || 30;
    const offsetX = 15;
    const offsetY = 15;
    let mouseX = 0;
    let mouseY = 0;
    let cursorX = 0;
    let cursorY = 0;
    let isMoving = false;
    let rafId = null;
    let cursorEnabled = true;
    
    // Check cookie on load
    const cookieValue = getCookie(COOKIE_NAME);
    if (cookieValue === 'false') {
      cursorEnabled = false;
      cursor.style.display = 'none';
    }
    
    function updateCursor() {
      if (!cursorEnabled) return;
      
      const dx = mouseX - cursorX;
      const dy = mouseY - cursorY;
      
      if (prefersReducedMotion) {
        // Instant positioning for reduced motion
        cursorX = mouseX;
        cursorY = mouseY;
      } else {
        // Smooth animation
        cursorX += dx * 0.15;
        cursorY += dy * 0.15;
      }
      
      cursor.style.left = (cursorX + offsetX) + 'px';
      cursor.style.top = (cursorY + offsetY) + 'px';
      
      cursor.classList.add('active');
      
      if (!prefersReducedMotion && (Math.abs(dx) > 0.1 || Math.abs(dy) > 0.1)) {
        rafId = requestAnimationFrame(updateCursor);
      } else {
        isMoving = false;
      }
    }
    
    function handleMouseMove(e) {
      mouseX = e.clientX;
      mouseY = e.clientY;
      
      if (!cursorEnabled) return;
      
      if (prefersReducedMotion) {
        // Update immediately for reduced motion
        updateCursor();
      } else if (!isMoving) {
        isMoving = true;
        rafId = requestAnimationFrame(updateCursor);
      }
    }
    
    function handleMouseLeave() {
      cursor.classList.remove('active');
      isMoving = false;
      if (rafId) {
        cancelAnimationFrame(rafId);
      }
    }
    
    // Store current mouse position globally for toggle function
    let currentMouseX = window.innerWidth / 2;
    let currentMouseY = window.innerHeight / 2;
    
    // Track mouse position even when cursor is disabled
    document.addEventListener('mousemove', function(e) {
      currentMouseX = e.clientX;
      currentMouseY = e.clientY;
    });
    
    // Expose toggle function globally
    window.toggleCustomCursor = function(enabled) {
      cursorEnabled = enabled;
      if (enabled) {
        cursor.style.display = '';
        // Immediately position cursor at current mouse position
        cursorX = currentMouseX;
        cursorY = currentMouseY;
        cursor.style.left = (cursorX + offsetX) + 'px';
        cursor.style.top = (cursorY + offsetY) + 'px';
        cursor.classList.add('active');
        // Trigger update to ensure it's visible
        mouseX = currentMouseX;
        mouseY = currentMouseY;
        if (prefersReducedMotion) {
          // No animation needed for reduced motion
          updateCursor();
        } else if (!isMoving) {
          isMoving = true;
          rafId = requestAnimationFrame(updateCursor);
        }
        setCookie(COOKIE_NAME, 'true', COOKIE_EXPIRY_DAYS);
      } else {
        cursor.style.display = 'none';
        cursor.classList.remove('active');
        isMoving = false;
        if (rafId) {
          cancelAnimationFrame(rafId);
        }
        setCookie(COOKIE_NAME, 'false', COOKIE_EXPIRY_DAYS);
      }
    };
    
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseleave', handleMouseLeave);
    
    // Initialize cursor position
    cursorX = window.innerWidth / 2;
    cursorY = window.innerHeight / 2;
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomCursor);
  } else {
    initCustomCursor();
  }
})();


/* Announcement toggle for custom cursor */
(function() {
  function initAnnouncementToggle() {
    const toggle = document.querySelector('.cc-announcement-toggle');
    if (!toggle) return;
    
    // Check cookie on load
    const cookieValue = document.cookie.split(';').find(c => c.trim().startsWith('custom_cursor_enabled='));
    const isEnabled = !cookieValue || cookieValue.split('=')[1] === 'true';
    
    if (isEnabled) {
      toggle.classList.add('active');
      toggle.setAttribute('title', 'Hide custom cursor');
    } else {
      toggle.classList.remove('active');
      toggle.setAttribute('title', 'Show custom cursor');
    }
    
    // Handle toggle click
    toggle.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const isCurrentlyActive = toggle.classList.contains('active');
      
      if (isCurrentlyActive) {
        // Turn OFF: Hide cursor
        toggle.classList.remove('active');
        toggle.setAttribute('title', 'Show custom cursor');
        if (window.toggleCustomCursor) {
          window.toggleCustomCursor(false);
        }
      } else {
        // Turn ON: Show cursor
        toggle.classList.add('active');
        toggle.setAttribute('title', 'Hide custom cursor');
        if (window.toggleCustomCursor) {
          window.toggleCustomCursor(true);
        }
      }
    });
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnnouncementToggle);
  } else {
    initAnnouncementToggle();
  }
})();


